// @ts-nocheck
import {Column} from 'react-table'
import {Model} from '@/_metronic/helpers'
import {
  TextCell,
  ActionsCell,
  CustomHeader
} from '@/components/table/columns'

import {BrandCell} from '../../../_components/columns/BrandCell'


const Columns: ReadonlyArray<Column<Model>> = [{
  Header: (props) => <CustomHeader tableProps={props} title='Name' className='min-w-70px sortable' />,
  id: 'name',
  Cell: ({...props}) => <TextCell content={props.data[props.row.index].name} />,
}, {
  Header: (props) => <CustomHeader tableProps={props} title='SLUG' className='min-w-70px text-end pe-0 sortable' />,
  id: 'slug',
  className: 'text-end pe-0',
  Cell: ({...props}) => <TextCell content={props.data[props.row.index].slug} />,
}, {
  Header: (props) => <CustomHeader tableProps={props} title='ICON' className='min-w-70px text-end pe-0 sortable' />,
  id: 'icon',
  className: 'text-end pe-0',
  Cell: ({...props}) => <BrandCell brand={props.data[props.row.index]} />,
}, {
  Header: (props) => (
    <CustomHeader tableProps={props} title='Actions' className='text-end min-w-100px' />
  ),
  id: 'actions',
  Cell: ({...props}) => (
    <ActionsCell
      itemForUpdate={props.data[props.row.index]}
      actions={[{
        icon: 'pencil',
        label: 'Edit',
        openModal: 'edit'
      }]}
    />
  )
}]

export {Columns}
